<template>
    <div v-if="simulation">
        <top-navbar :breadcrumb="breadcrumb"></top-navbar>

        <div class="container-fluid mt--6">
            <div class="row">
                <div class="col">
                    <card class="card-pricing bg-gradient-default border-0 text-center mb-1"
                        header-classes="bg-transparent"
                        body-classes="px-lg-7"
                        footer-classes="bg-transparent">

                        <div class="display-3 text-white mb-2">
                            <span class="text-muted d-inline">{{ degree.name }} /</span>
                            {{ simulation.name }}
                        </div>

                        <div class="display-4 text-white mb-2">
                            <small>({{ degree.lang }})</small>
                        </div>
                    </card>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <log
                        :log="log"
                        :degree="degree"
                        :simulation="simulation"
                        :form="form"
                        :competencies="competencies"
                    ></log>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Log from './logs/Log'
    import CrudClient from '@trax/classes/CrudClient'
    import CrudForm from '@trax/classes/CrudForm'

    export default {

        components: {
            Log
        },

        data() {
            let client = new CrudClient('/socrates/api/front/logs')
            return {
                form: new CrudForm(client, this.mapData, this.unmapData),
                degree: null,
                simulation: null,
                log: null,
                competencies: null,
            }
        },

        computed: {

            breadcrumb() {
                return [
                    {
                        name: this.$t('common.degrees'),
                        route: '/socrates/ui/training/degrees'
                    },
                    {
                        name: this.degree.name,
                        route: '/socrates/ui/training/degrees/' + this.$route.params.degreeId
                    },
                    {
                        name: this.simulation.name,
                    },
                ]
            }
        },

        beforeRouteEnter(to, from, next) {
            axios.get('/socrates/api/front/simulations/'+to.params.simulationId, {params: {
                relations: ['degree', 'log'],
                accessors: ['competencies'],
            }})
            .then(resp => {
                next(vm => {
                    vm.degree = resp.data.data.degree
                    vm.simulation = resp.data.data
                    vm.log = resp.data.data.log
                    vm.competencies = resp.data.data.competencies
                    vm.form.init(vm, 'form')

                    vm.updated = function(resp) {
                        vm.log = resp.data.data
                        vm.form.update(vm.log).then(vm.updated)
                    }
                    vm.form.update(vm.log).then(vm.updated)
                })
            })
        },

        methods: {
            
            mapData(log) {
                return {
                    id: log ? log.id : null,
                    objectives: log ? log.objectives : null,
                    scenario: log ? log.scenario : null,
                    flights: log ? log.flights : null,
                    technical_means: log ? log.technical_means : null,
                    current_situation: log ? log.current_situation : null,
                    zones: log ? log.zones : null,
                    runways: log ? log.runways : null,
                    qnh: log ? log.qnh : null,
                    atis: log ? log.atis : null,
                    other: log ? log.other : null,
                    pilots_number: log ? log.pilots_number : null,
                }
            },

            unmapData(data) {
                const log = {...data}
                log.simulation_id = this.simulation.id
                return log
            },
        }
    }
</script>
